import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import { LanguageMap } from '../firebase/firestore/documents/user';

export const hexToRgba = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

// function to determine background color for availability selection
export const getGradientBackground = (availability: string, deg?: string) => {
  return availability === 'Day'
    ? `linear-gradient(${deg ?? '5.6'}deg, #E9ECF8 49%, #fff 51%)`
    : `linear-gradient(${deg ?? '5.6'}deg, #fff 49%, #E9ECF8 51%)`;
};

// istanbul ignore next
function cleanEmptyHtmlBlocks(html: string): string {
  const cleaned = html
    .replace(/<p>(&nbsp;|\s|<br\s*\/?>)*<\/p>/gi, '') // remove empty paragraphs
    .replace(/\s+/g, ' ') // normalize whitespace
    .trim();

  return cleaned === '' ? '' : html;
}

// for weekends and weekdays
export const weekDays = ['mon', 'tue', 'wed', 'thu', 'fri'];
export const weekEnds = ['sat', 'sun'];

// istanbul ignore next
export function sanitizeOfferConditions(
  input: string | LanguageMap<string> | undefined,
): string | LanguageMap<string> | undefined | null {
  if (isString(input) && !isEmpty(input)) {
    return {
      en: cleanEmptyHtmlBlocks(input),
    };
  }

  if (isObject(input) && input !== null) {
    const allEmpty = Object.values(input).every((value) => value === '');
    if (allEmpty) {
      return null;
    }

    const cleanedMap: LanguageMap<string> = {};

    Object.entries(input).forEach(([lang, content]) => {
      const cleaned = content !== undefined ? cleanEmptyHtmlBlocks(content) : '';
      cleanedMap[lang as keyof LanguageMap<string>] = cleaned;
    });

    return cleanedMap;
  }

  return input;
}

export const translateDecimalSymbolAccordingToLanguage = (value: number | string | null | undefined, language: string) => {
  // istanbul ignore next
  if (isNil(value)) {
    return value;
  }
  switch (language) {
    case 'fr':
      return String(value).replace('.', ',');
    case 'en':
      return String(value).replace(',', '.');
    // istanbul ignore next
    default:
      return value;
  }
};
